import { http } from "./httpService";

export const getAgents = () => http.get("/admin/agents/list");
// Public, unauthenticated — powers the embeddable per-agency "Find Agent" widget.
export const getAgencyEmbed = (agencyId) => http.get(`/agencies/${agencyId}/embed`);
export const getAgentById = (id) => http.get(`/admin/agent/id/${id}`);
export const updateAgent = (data, id) => http.postFormData(`/admin/agent/${id}`, data, {
  headers: {}, // no need to set Content-Type manually
});
export const getLocations = ({ perpage, page, search }) => http.get(`/public/locations?per_page=${perpage}&page=${page}${search ? `&search=${encodeURIComponent(search)}` : ''}`);
// Cheap, single-record fetch for OrganizationSchema (rendered site-wide on
// every page) — pulling the whole location list there would be wasteful.
export const getHeadquartersLocation = () => http.get(`/public/locations?is_headquarters=1&per_page=1`);
export const createAgentConsultation = (data) => http.postFormData("/agent/save-consultation", data, {
  headers: {
    Accept: "application/json",
  },
});
// export const updateUser = (id, data) =>  http.put(`/admin/agent/${id}`, data);
// export const deleteUser = (id) => http.delete(`/users/${id}`);